(function () {
  const LANDING_CONTENT_NAMES = {
    toefl2026: 'Santa TOEFL 7-day free trial',
    'santa-kickstart': 'Santa TOEFL 3-day free trial'
  };
  const LANDING_SELECTOR = Object.keys(LANDING_CONTENT_NAMES)
    .map(id => `#${id}`)
    .join(', ');
  const META_PIXEL_ID = '1642603806774287';
  const GOOGLE_ADS_ID = 'AW-18154541104';
  const GOOGLE_ADS_CONVERSION_ID = 'AW-18154541104/6qgICL6lr-wcELCg4dBD';
  const GOOGLE_ADS_NAVIGATION_TIMEOUT = 2000;
  const FREE_TRIAL_HOST = 'ai.aitutorsanta.com';
  const FREE_TRIAL_PATH = '/onboarding/intro';
  const landing = document.querySelector(LANDING_SELECTOR);

  if (!landing || window.santaFreeTrialLeadTrackingInitialized) return;

  window.santaFreeTrialLeadTrackingInitialized = true;

  let metaInitialized = false;
  let googleInitialized = false;
  let privacyReady = false;

  const appendScript = src => {
    if (document.querySelector(`script[src="${src}"]`)) return;

    const script = document.createElement('script');
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
  };

  const isMarketingAllowed = () => {
    const customerPrivacy = window.Shopify?.customerPrivacy;

    return typeof customerPrivacy?.marketingAllowed === 'function'
      && customerPrivacy.marketingAllowed();
  };

  const ensureMetaPixel = () => {
    if (metaInitialized) return;

    if (typeof window.fbq !== 'function') {
      const fbq = function () {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, arguments);
        } else {
          fbq.queue.push(arguments);
        }
      };

      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      window.fbq = fbq;
      window._fbq = fbq;
      appendScript('https://connect.facebook.net/en_US/fbevents.js');
    }

    window.fbq('set', 'autoConfig', false, META_PIXEL_ID);
    window.fbq('init', META_PIXEL_ID);
    metaInitialized = true;
  };

  const ensureGoogleTag = () => {
    if (googleInitialized) return;

    window.dataLayer = window.dataLayer || [];

    if (typeof window.gtag !== 'function') {
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      appendScript(`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`);
      window.gtag('js', new Date());
    }

    window.gtag('config', GOOGLE_ADS_ID, { send_page_view: false });
    googleInitialized = true;
  };

  const isFreeTrialCta = link => {
    try {
      const url = new URL(link.href, window.location.href);

      return url.hostname === FREE_TRIAL_HOST
        && url.pathname === FREE_TRIAL_PATH
        && url.searchParams.get('domain') === 'TOEFL';
    } catch {
      return false;
    }
  };

  const shouldWaitForGoogle = (event, link) => {
    const isPrimaryClick = typeof event.button !== 'number' || event.button === 0;
    const opensCurrentPage = !link.target || link.target === '_self';

    return typeof event.preventDefault === 'function'
      && !event.defaultPrevented
      && isPrimaryClick
      && opensCurrentPage
      && !event.metaKey
      && !event.ctrlKey
      && !event.shiftKey
      && !event.altKey;
  };

  const trackGoogleConversion = (event, link) => {
    ensureGoogleTag();

    const conversion = {
      send_to: GOOGLE_ADS_CONVERSION_ID
    };

    if (shouldWaitForGoogle(event, link)) {
      let hasNavigated = false;
      const navigate = () => {
        if (hasNavigated) return;
        hasNavigated = true;
        window.location.href = link.href;
      };

      event.preventDefault();
      window.setTimeout(navigate, GOOGLE_ADS_NAVIGATION_TIMEOUT);
      conversion.event_callback = navigate;
      conversion.event_timeout = GOOGLE_ADS_NAVIGATION_TIMEOUT;
    }

    window.gtag('event', 'conversion', conversion);
  };

  const initializeMetaWhenAllowed = () => {
    if (!privacyReady || !isMarketingAllowed()) return;
    ensureMetaPixel();
  };

  const handleClick = event => {
    const link = event.target?.closest?.('a');

    if (!link || !landing.contains(link) || !isFreeTrialCta(link)) return;
    if (!privacyReady || !isMarketingAllowed()) return;

    ensureMetaPixel();
    window.fbq('trackSingle', META_PIXEL_ID, 'StartTrial', {
      content_name: LANDING_CONTENT_NAMES[landing.id] || 'Santa TOEFL free trial',
      content_category: 'TOEFL Free Trial'
    });
    trackGoogleConversion(event, link);
  };

  const initPrivacy = () => {
    if (typeof window.Shopify?.customerPrivacy?.marketingAllowed === 'function') {
      privacyReady = true;
      initializeMetaWhenAllowed();
      return;
    }

    if (typeof window.Shopify?.loadFeatures !== 'function') return;

    window.Shopify.loadFeatures([{
      name: 'consent-tracking-api',
      version: '0.1'
    }], error => {
      if (error || typeof window.Shopify?.customerPrivacy?.marketingAllowed !== 'function') return;

      privacyReady = true;
      initializeMetaWhenAllowed();
    });
  };

  landing.addEventListener('click', handleClick);

  document.addEventListener('visitorConsentCollected', () => {
    privacyReady = typeof window.Shopify?.customerPrivacy?.marketingAllowed === 'function';
    initializeMetaWhenAllowed();
  });

  initPrivacy();
})();
